import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const RequireAuth = ({ children }) => {
  const { status, lastUid } = useAuth();
  const location = useLocation();

  if (status === 'loading' || status === 'checking') {
    return (
      <div className="full-page-center" aria-label="Loading">
        <div className="spinner" />
      </div>
    );
  }
  if (status !== 'signedIn') {
    // uid: whose page this was, so Login reopens it only for the same account.
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search, uid: lastUid?.() || null }} />;
  }
  return children;
};

export default RequireAuth;
